<script>
import CoreComponent from '../CoreComponent.vue'

export default {
    extends: CoreComponent
}
</script>

<style lang="scss">
@import '../image/image.scss';
</style>
